<template>
    <div class="m-t-10">
        <hr>
        <b-collapse
            :open.sync="open"
            @open="open = (open == true)? false : true"
            class="card"
            animation="slide">
            <div
                slot="trigger"
                slot-scope="props"
                class="card-header"
                role="button">
                <p class="card-header-title">
                    Metodos de envio 
                </p>
                <a class="card-header-icon" style="color:#000;">
                    <b-icon
                        :icon="props.open ? 'times' : 'plus'">
                    </b-icon>
                </a>
            </div>
            <div class="card-content">
                <div class="content">
                    <p class="is-size-7" v-for="envio in envios" :key="envio.id">
                        <b>*{{envio.title}} <span v-if="envio.freeFrom > 0" class="tag is-success is-size-small is-rounded">Gratis a partir de UY${{envio.freeFrom}}</span>:</b> {{envio.details}}
                    </p>
                </div>
            </div>
        </b-collapse>      
    </div>
</template>

<script>
export default {
    props:{
        envios:{
            type:Array,
            default:new Array([])
        }
    },
    data(){
        return{
            open:false
        }
    }
}
</script>